import { Pipe, PipeTransform } from '@angular/core';

import { StaticMessage } from '@shared/enums';
import { getStaticMessage } from '@shared/utils';

@Pipe({
  name: 'staticMessage',
})
export class StaticMessagePipe implements PipeTransform {
  transform(messageType: StaticMessage, ...params: any[]): string {
    return getStaticMessage(messageType, ...params);
  }
}
